
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vrgzu_180oy_93",
  "recovery": "awsui_recovery_vrgzu_180oy_107"
};
  